"use strict";
function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
exports.isPromise = isPromise;



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/util/isPromise.js
// module id = 69
// module chunks = 0 1